import React, { useState, useRef } from "react";
import ToastElement from "../../../Components/UiComponents/ToastElement";
import Loader from "../../../Components/UiComponents/Loader";
import { Dialog } from "primereact/dialog";
import ButtonElement from "../../../Components/UiComponents/ButtonElement";
import _ from "lodash";
import { useForm, Controller } from "react-hook-form";
import DropdownElement from "../../../Components/UiComponents/DropdownElement";
import InputTextElementElement from "../../../Components/UiComponents/InputTextElement";
import CalendarElement from "../../../Components/UiComponents/CalendarElement";
import { getSeq, create } from "../../../Services/frameworkService";
import moment from "moment";

const CreateNewProgramme = (props) => {
    const [loading, setLoading] = useState(false);
    const [frameworkDetails, setFrameworkDetails] = useState({});

    const toastRef = useRef();
    const { control, handleSubmit, formState: { errors }, reset } = useForm();

    const enduser = localStorage.getItem("enduser");
    if (enduser) {
        var tmpData = JSON.parse(enduser);
    }

    const closePopup = () => {
        props.onHide();
    };

    const clearForm = () => {
        reset();
    };

    const onSubmit = async (programmeData) => {
        try {
            setLoading(true)
            var seqData = await getSeq(tmpData.customer)
            if (seqData && seqData.data) {
                var nxtSeq = 1;
                if (!_.isEmpty(seqData.data)) {
                    nxtSeq = (seqData.data[0].framework_seq) ? (seqData.data[0].framework_seq + 1) : 1;
                }
                if (nxtSeq !== '') {
                    programmeData.framework_seq = nxtSeq;
                    programmeData.customer_id = tmpData.customer;
                    programmeData.region = programmeData.region != undefined ? programmeData.region.label : '';
                    programmeData.framework_classification = programmeData.framework_classification != undefined ? programmeData.framework_classification.label : '';
                    programmeData.framework_name = programmeData.framework.label;
                    programmeData.framework_label = programmeData.framework_label;
                    programmeData.framework_type = programmeData.framework_type != undefined ? programmeData.framework_type.label : '';
                    programmeData.business_developer = frameworkDetails.business_developer != undefined ? frameworkDetails.business_developer : '';
                    programmeData.main_board_sponsor = frameworkDetails.main_board_sponsor != undefined ? frameworkDetails.main_board_sponsor : '';
                    programmeData.relationship_owner = frameworkDetails.relationship_owner != undefined ? frameworkDetails.relationship_owner : '';
                    programmeData.next_review = programmeData.next_review != null ? moment(programmeData.next_review).format('DD-MM-YYYY') : '';
                    var createdData = await create(programmeData)
                    if (createdData && createdData.data.success) {
                        nxtSeq = "";
                        toastRef.current.showToast({
                            type: 'success',
                            message: props.moduleName + "  Created successfully!"
                        });
                        setLoading(false)
                        clearForm();
                        setTimeout(() => { closePopup() }, 500)
                    } else {
                        toastRef.current.showToast({
                            type: 'error',
                            message: createdData.data.message
                        });
                        setLoading(false)
                    }
                }
            }
        } catch (error) {
            toastRef.current.showToast({
                type: "error",
                message: "An error occurred. Please try again or contact Admin.",
            });
        } finally {
            setLoading(false)
        }
    }

    const renderFooter = () => {
        return (
            <div className="cancel-footer">
                <div className='align-center justify-end pb-0'>
                    <ButtonElement label="Cancel" className="cancel-new-button" onClick={() => { closePopup(); }} />
                    <ButtonElement type="submit" label="Create" className="save-button" onClick={handleSubmit(onSubmit)} />
                </div>
            </div>
        );
    }

    return (
        <div>
            <ToastElement ref={toastRef} />
            <Loader loading={loading} />
            <Dialog
                header={_.find(props.frameSection, { section_name: "New Framework" })?.display_name}
                visible={props.visible}
                position={'right'}
                onHide={() => { closePopup() }}
                footer={renderFooter()}
                className="width-46"
                draggable={false}
            >
                <div className="new-field">
                    <form >
                        <div className="form-group row align-items-center mb-0 mt-0">
                            <div className="col-md-5 pl-0">
                                <label className="form-label text-left">
                                    {_.find(props.commanFieldsNew, { field_name: "Region" })?.display_name}:
                                </label>
                            </div>
                            <div className="col pr-0">
                                <Controller
                                    name="region"
                                    control={control}
                                    style={{ innerHeight: 10 }}
                                    render={({ field }) => {
                                        return (
                                            <DropdownElement
                                                onChange={(e) => field.onChange(e.value)}
                                                id="region"
                                                options={(props.options.regionV1 != undefined && props.options.regionV1.length > 0) ? props.options.regionV1 : []}
                                                optionLabel="label"
                                                placeholder="-- Please select --"
                                                className="w-full"
                                                {...field}
                                                maxSelectedLabels={1}
                                            />
                                        );
                                    }}
                                />
                            </div>
                        </div>
                        <div className="form-group row align-items-center mb-0 mt-0">
                            <div className="col-md-5 pl-0">
                                <label className="form-label text-left">
                                    {_.find(props.frameNew, { field_name: "Framework" })?.display_name}:
                                </label>
                            </div>
                            <div className="col pr-0">
                                <Controller
                                    name="framework"
                                    control={control}
                                    rules={{ required: "Framework is required" }}
                                    style={{ innerHeight: 10 }}
                                    render={({ field }) => {
                                        return (
                                            <DropdownElement
                                                onChange={(e) => field.onChange(e.value)}
                                                id="framework"
                                                options={(props.options.framework != undefined && props.options.framework.length > 0) ? props.options.framework : []}
                                                optionLabel="label"
                                                placeholder="-- Please select --"
                                                className="w-full"
                                                {...field}
                                                maxSelectedLabels={1}
                                            />
                                        );
                                    }}
                                />
                                {errors.framework && (
                                    <small className="text-red-500 color-red">
                                        {errors.framework.message}
                                    </small>
                                )}
                            </div>
                        </div>
                        <div className="form-group row align-items-center mb-0 mt-0">
                            <div className="col-md-5 pl-0">
                                <label className="form-label text-left">
                                    {_.find(props.frameNew, { field_name: "Framework Version Label" })?.display_name}:
                                </label>
                            </div>
                            <div className="col pr-0">
                                <Controller
                                    name="framework_label"
                                    control={control}
                                    rules={{ required: "Framework Version Label must be 2-50 characters in alphanumeric" }}
                                    render={({ field }) => (
                                        <InputTextElementElement id="framework_label" {...field} />
                                    )}
                                />
                                {errors.framework_label && (
                                    <small className="text-red-500 color-red">
                                        {errors.framework_label.message}
                                    </small>
                                )}
                            </div>
                        </div>
                        <div className="form-group row align-items-center mb-0 mt-0">
                            <div className="col-md-5 pl-0">
                                <label className="form-label text-left">
                                    {_.find(props.frameNew, { field_name: "Framework Size" })?.display_name}:
                                </label>
                            </div>
                            <div className="col pr-0">
                                <Controller
                                    name="framework_type"
                                    control={control}
                                    style={{ innerHeight: 10 }}
                                    render={({ field }) => {
                                        return (
                                            <DropdownElement
                                                onChange={(e) => field.onChange(e.value)}
                                                id="framework_type"
                                                options={(props.options.frameworkSize != undefined && props.options.frameworkSize.length > 0) ? props.options.frameworkSize : []}
                                                optionLabel="label"
                                                placeholder="-- Please select --"
                                                className="w-full"
                                                {...field}
                                                maxSelectedLabels={1}
                                            />
                                        );
                                    }}
                                />
                            </div>
                        </div>
                        <div className="form-group row align-items-center mb-0 mt-0">
                            <div className="col-md-5 pl-0">
                                <label className="form-label text-left">
                                    {_.find(props.frameNew, { field_name: "Framework Classification" })?.display_name}:
                                </label>
                            </div>
                            <div className="col pr-0">
                                <Controller
                                    name="framework_classification"
                                    control={control}
                                    style={{ innerHeight: 10 }}
                                    render={({ field }) => {
                                        return (
                                            <DropdownElement
                                                onChange={(e) => field.onChange(e.value)}
                                                id="framework_classification"
                                                options={(props.options.frameworkClassification != undefined && props.options.frameworkClassification.length > 0) ? props.options.frameworkClassification : []}
                                                optionLabel="label"
                                                placeholder="-- Please select --"
                                                className="w-full"
                                                {...field}
                                                maxSelectedLabels={1}
                                            />
                                        );
                                    }}
                                />
                            </div>
                        </div>
                        <div className="form-group row align-items-center mb-0 mt-0">
                            <div className="col-md-5 pl-0">
                                <label className="form-label text-left">
                                    {_.find(props.commanFieldsNew, { field_name: "Business Developer" })?.display_name}:
                                </label>
                            </div>
                            <div className="col pr-0">
                                <Controller
                                    name="business_developer"
                                    control={control}
                                    style={{ innerHeight: 10 }}
                                    render={({ field }) => {
                                        const userOption = props.options.userDetails.map((user) => ({
                                            value: user._id,
                                            label: user.firstname + ' ' + user.surname,
                                        }));
                                        return (
                                            <DropdownElement
                                                id="business_developer"
                                                options={(userOption != undefined && userOption.length > 0) ? userOption : []}
                                                optionValue="value"
                                                optionLabel="label"
                                                placeholder="-- Please select --"
                                                className="w-full"
                                                {...field}
                                                maxSelectedLabels={1}
                                                onChange={(e) => {
                                                    const selectedOption = userOption.find(option => option.value === e.value);
                                                    setFrameworkDetails(prevData => ({
                                                        ...prevData,
                                                        business_developer: selectedOption.label
                                                    }));
                                                    field.onChange(e.value)
                                                }}
                                            />
                                        );
                                    }}
                                />
                            </div>
                        </div>
                        <div className="form-group row align-items-center mb-0 mt-0">
                            <div className="col-md-5 pl-0">
                                <label className="form-label text-left">
                                    {_.find(props.commanFieldsNew, { field_name: "Relationship Owner" })?.display_name}:
                                </label>
                            </div>
                            <div className="col pr-0">
                                <Controller
                                    name="relationship_owner"
                                    control={control}
                                    style={{ innerHeight: 10 }}
                                    render={({ field }) => {
                                        const userOption = props.options.userDetails.map((user) => ({
                                            value: user._id,
                                            label: user.firstname + ' ' + user.surname,
                                        }));
                                        return (
                                            <DropdownElement
                                                id="relationship_owner"
                                                options={(userOption != undefined && userOption.length > 0) ? userOption : []}
                                                optionLabel="label"
                                                optionValue="value"
                                                placeholder="-- Please select --"
                                                className="w-full"
                                                {...field}
                                                maxSelectedLabels={1}
                                                onChange={(e) => {
                                                    const selectedOption = userOption.find(option => option.value === e.value);
                                                    setFrameworkDetails(prevData => ({
                                                        ...prevData,
                                                        relationship_owner: selectedOption.label
                                                    }));
                                                    field.onChange(e.value)
                                                }}
                                            />
                                        );
                                    }}
                                />
                            </div>
                        </div>
                        <div className="form-group row align-items-center mb-0 mt-0">
                            <div className="col-md-5 pl-0">
                                <label className="form-label text-left">
                                    {_.find(props.commanFieldsNew, { field_name: "Main Board Sponsor" })?.display_name}:
                                </label>
                            </div>
                            <div className="col pr-0">
                                <Controller
                                    name="main_board_sponsor"
                                    control={control}
                                    style={{ innerHeight: 10 }}
                                    render={({ field }) => {
                                        const userOption = props.options.userDetails.map((user) => ({
                                            value: user._id,
                                            label: user.firstname + ' ' + user.surname,
                                        }));
                                        return (
                                            <DropdownElement
                                                id="main_board_sponsor"
                                                options={(userOption != undefined && userOption.length > 0) ? userOption : []}
                                                optionLabel="label"
                                                optionValue="value"
                                                placeholder="-- Please select --"
                                                className="w-full"
                                                {...field}
                                                maxSelectedLabels={1}
                                                onChange={(e) => {
                                                    const selectedOption = userOption.find(option => option.value === e.value);
                                                    setFrameworkDetails(prevData => ({
                                                        ...prevData,
                                                        main_board_sponsor: selectedOption.label
                                                    }));
                                                    field.onChange(e.value)
                                                }}
                                            />
                                        );
                                    }}
                                />
                            </div>
                        </div>
                        <div className="form-group row align-items-center mb-0 mt-0">
                            <div className="col-md-5 pl-0">
                                <label className="form-label text-left">
                                    {_.find(props.frameNew, { field_name: "Total Framework Value" })?.display_name + ' (' + props.currency + ')'}:
                                </label>
                            </div>
                            <div className="col pr-0">
                                <Controller
                                    name="total_framework_value"
                                    control={control}
                                    render={({ field }) => (
                                        <InputTextElementElement id="total_framework_value" {...field} />
                                    )}
                                />
                            </div>
                        </div>
                        <div className="form-group row align-items-center mb-0 mt-0">
                            <div className="col-md-5 pl-0">
                                <label className="form-label text-left">
                                    {_.find(props.frameNew, { field_name: "Maximum Income" })?.display_name + ' (' + props.currency + ')'}:
                                </label>
                            </div>
                            <div className="col pr-0">
                                <Controller
                                    name="maximum_income"
                                    control={control}
                                    render={({ field }) => (
                                        <InputTextElementElement id="maximum_income" {...field} />
                                    )}
                                />
                            </div>
                        </div>
                        <div className="form-group row align-items-center mb-0 mt-0">
                            <div className="col-md-5 pl-0">
                                <label className="form-label text-left">
                                    {_.find(props.commanFieldsNew, { field_name: "Next Review" })?.display_name}:
                                </label>
                            </div>
                            <div className="col pr-0">
                                <Controller
                                    name="next_review"
                                    control={control}
                                    render={({ field }) => (
                                        <CalendarElement
                                            id="next_review"
                                            {...field}
                                            placeholder="Choose a date"
                                        />
                                    )}
                                />
                            </div>
                        </div>
                    </form>
                </div>
            </Dialog>
        </div>
    )
}

export default CreateNewProgramme